export default {
    client: null,
    channel: null,
}